 
import React, {useCallback, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {getDateByCustomFormat, DATE_FORMATS} from 'utils/date';
import useUserStore from 'common/stores/user';

import {EditIcon, Layout} from '@phonectas/unifon-ui-kit';
import {StyledNoSelectText, StyledPositionBtn, StyledLayoutPaddingLeft} from 'common/styled';
import TextDivWithLabel from 'common/components/TextDivWithLabel';
import EditNoteDialog from './EditNoteDialog';
import {BmoNoteResponse} from 'common/types/store/bmoTypes';

interface NotesProps {
	notesData: BmoNoteResponse[];
	userId: string;
	caseId: string;
}


const Notes: React.FC<NotesProps> = ({notesData, userId, caseId}) => {
	const [t] = useTranslation();
	const {user} = useUserStore();
	const sortedNotesData = [...notesData].sort(
		(a, b) => new Date(b.date ?? '').getTime() - new Date(a.date ?? '').getTime()
	);
	const isCurrentUser = userId === user?.catalogID;
	const author = (note: BmoNoteResponse) => `${note?.authorFirstName} ${note?.authorLastName}`;
	const [currentNote, setCurrentNote] = useState<BmoNoteResponse | null>(null);
	const [showEditNoteDialog, setShowEditNoteDialog] = useState(false);
	const onOpenEditNoteDialog = useCallback((note: BmoNoteResponse) => {
		setCurrentNote(note);
		setShowEditNoteDialog(true);
	}, []);
	const onCloseEditNoteDialog = useCallback(() => {
		setShowEditNoteDialog(false);
	}, []);

	return (
		<StyledLayoutPaddingLeft direction="column" fullWidth>
			{
				sortedNotesData?.map((note) => (
					<Layout
						fullWidth
						direction="column"
						key={note.id}
						style={{borderTop: 'solid 1px gray'}}
					>
						<Layout fullWidth style={{gap: '5px'}}>
							<table>
								<tbody>
									<tr>
										<td><StyledNoSelectText>{t('Author')}:</StyledNoSelectText></td>
										<td>{author(note)}</td>
									</tr>
									<tr>
										<td><StyledNoSelectText>{t('Company')}:</StyledNoSelectText></td>
										<td>{note?.author}</td>
									</tr>
									<tr>
										<td><StyledNoSelectText>{t('Date')}:</StyledNoSelectText></td>
										<td>{getDateByCustomFormat(note?.date, DATE_FORMATS.DD_MM_YYYY_HH_mm)}</td>
									</tr>
								</tbody>
							</table>
						</Layout>
						<div style={{position: 'relative', width: '100%'}}>
							{
								isCurrentUser && user?.name === author(note) && (
									<StyledPositionBtn
										onClick={() => onOpenEditNoteDialog(note)}
									>
										<EditIcon
											color="blue"
											size="md"
										/>
									</StyledPositionBtn>
								)
							}
							<TextDivWithLabel text={note?.text ?? ''}/>
						</div>
					</Layout>
				))
			}
			{
				// Keyed and unmounted on close so the dialog always starts from the note that was clicked.
				currentNote && showEditNoteDialog && (
					<EditNoteDialog
						key={currentNote.id}
						show={showEditNoteDialog}
						onClose={onCloseEditNoteDialog}
						note={currentNote}
						caseId={caseId}
					/>
				)
			}
		</StyledLayoutPaddingLeft>
	);
}

export default Notes;
